import React from "react";
import { AccessItem } from "./AccessItem";
import { PendingAccessControls } from "./PendingAccessControls";

interface PendingInviteRowProps {
  email: string;
  canRevokeAccess: boolean;
  onResend?: () => Promise<void>;
  onRevoke?: () => Promise<void>;
  isActive?: boolean;
  onMenuToggle?: (isOpen: boolean) => void;
  source?: React.ReactNode;
}

export const PendingInviteRow: React.FC<PendingInviteRowProps> = ({
  email,
  canRevokeAccess,
  onResend,
  onRevoke,
  isActive,
  onMenuToggle,
  source,
}) => (
  <AccessItem
    primaryText={email}
    tooltipText={email}
    isPending
    source={source}
    isActive={isActive}
    permissionLabel={
      <PendingAccessControls
        email={email}
        canRevokeAccess={canRevokeAccess}
        onResend={onResend}
        onRevoke={onRevoke}
        onMenuToggle={onMenuToggle}
      />
    }
  />
);
